import React from 'react';
import { Col } from '../../../lib/utils';
import SvgIcon from '../../../components/SvgIcon';
import { colors } from '../../../lib/colors';

type Props = {
    /** 아이콘 크기 */
    iconSize?: number;
    /** 아이콘 색상 */
    iconFill?: string;
    /** 아이콘 클래스 */
    iconClassName?: string;

    // 원크기
    width?: number;
    height?: number;

    /** 오른쪽 여백 */
    mr?: number;
};

const FeedCenterStatisticsFeedWritingPercentIcon = ({
    iconSize = 32,
    iconFill = colors.primary,
    iconClassName = '',
    width = 64,
    height = 64,
    mr = 12,
}: Props) => {
    return (
        <Col
            style={{
                width: `${width}px`,
                height: `${height}px`,
            }}
            className={`justify-center items-center border-[0.25px] border-solid border-[#427BE826] rounded-[50px] bg-[#E6EEFF] mr-[${mr}px]`}
        >
            <SvgIcon
                name="SvgCenterStatisticsFeedWritingPercent"
                size={iconSize}
                fill={iconFill}
                className={iconClassName}
            />
        </Col>
    );
};

export default FeedCenterStatisticsFeedWritingPercentIcon;
